// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductPreviews_container__xLs6t","addToList":"ProductPreviews_addToList__b2F6e","productPreview":"ProductPreviews_productPreview__yh4_C"};